import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useMyMealsMenuContext } from "../../../../../MyMeals/MyMealsMenuContext/MyMealsMenuContext";
import { useCompany } from "../../../../../Shared/components/CompanyProvider/CompanyProvider";
import { chooseOrReviewMealsButtonClickHandler } from "../../../../../Shared/components/Navigation/navigationUtils";
import { OrderDetailsText } from "../../utils/OrderDetailsAccordion-types";
import { tokenReplace } from "../../../../../Shared/utils/tokenReplacement";
// ** Button component for choosing or reviewing meals.
export const ChooseOrReviewMealsBtn = ({ showMealsButton, HasMenuSet, OrderIsUpcoming, orderNumber, subscriptionLinkId, AllMealDaysPastCutOff, mappedMeals, orderIsSkipped, }) => {
    const navigate = useNavigate();
    const { tokenMap } = useCompany();
    const { setSelectedSubLinkId } = useMyMealsMenuContext();
    // The ability to actually view MyMeals when all days are past cutoff
    // was removed (or inadvertently removed). Therefore, instead of navigating to my meals just
    // to see a message that you can't choose meals, we just won't show the button at all.
    if (AllMealDaysPastCutOff)
        return null;
    // Conditions determining the button's state and behavior.
    const canReviewOrChooseMeals = showMealsButton && !OrderIsUpcoming; // user can review or choose meals if the order isn't upcoming.
    const canChooseMeals = showMealsButton && OrderIsUpcoming && HasMenuSet; // user can choose meals for upcoming orders.
    const buttonText = tokenReplace(OrderDetailsText.CHOOSE_MEALS, false, tokenMap);
    const onClick = () => chooseOrReviewMealsButtonClickHandler(setSelectedSubLinkId, subscriptionLinkId, canReviewOrChooseMeals, navigate, orderNumber, canChooseMeals, mappedMeals);
    // Button for reviewing or choosing meals based on conditions.
    if (canReviewOrChooseMeals || canChooseMeals) {
        return (_jsx(Button, Object.assign({ size: "medium", fullWidth: true, variant: "outlined", color: "primary", 
            // Disable button if the order is skipped.
            disabled: orderIsSkipped, onClick: onClick }, { children: buttonText })));
    }
    // Return null if none of the conditions are met.
    return null;
};
